import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { AuthFacade, AuthRoutes } from '@rx-applications/shared/auth/data-access';

export const invitationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authFacade = inject(AuthFacade);

  const token: string = route.queryParamMap.get('token');
  if (!token) {
    return of(router.createUrlTree([`/${AuthRoutes.Login}`]));
  }

  authFacade.validateInvitation(token);
  return combineLatest([authFacade.isInvitationValid$, authFacade.isLoading$]).pipe(
    filter(([_, loading]) => !loading),
    switchMap(([isInvitationValid]) =>
      isInvitationValid ? of(true) : of(router.createUrlTree([`/${AuthRoutes.InvalidInvitation}`])),
    ),
  );
};
